import React, { PropTypes, Component } from 'react'
import moment from 'moment-timezone'
import Measure from 'react-measure'

import './AliadaProfileAvailability.scss'
import Page from 'components/AvailabilityCalendarPage'
import AliadaProfileAvailabilityHeader from './components/AliadaProfileAvailabilityHeader'
import { formatDate } from 'utils/dates'
import { TIMEZONE } from '@src/globals'

class AliadaProfileAvailability extends Component {
  constructor (props) {
    super(props)

    this.state = {
      page: 0,
      availability: this.groupAvailabilityByDay(props.availability),
      daysPerPage: 7,
      selectedDate: props.dateSelected
    }

    this.onPageChange = this.onPageChange.bind(this)
    this.setDaysPerPage = this.setDaysPerPage.bind(this)
    this.onDateSelected = this.onDateSelected.bind(this)
    this.onButtonClick = this.onButtonClick.bind(this)
  }

  groupAvailabilityByDay (availability) {
    const result = {}
    let daysToReturn = 7

    for (let datetime in availability) {
      const day = datetime.split('T')[0]
      const newDay = !(day in result)

      if (newDay) {
        daysToReturn--
        if (daysToReturn < 0) {
          break
        }
        result[day] = {
          date: moment.tz(day, TIMEZONE),
          availability: []
        }
      }

      result[day].availability.push({
        date: moment.tz(datetime, TIMEZONE),
        available: availability[datetime]
      })
    }

    return result
  }

  onPageChange (newPage) {
    this.setState({ page: newPage })
  }

  setDaysPerPage (dimensions) {
    const dayWidth = 80
    const maxDaysPerPage = 7

    const daysPerPage = Math.min(Math.floor(dimensions.width / dayWidth), maxDaysPerPage)

    this.setState({daysPerPage})
  }

  onDateSelected (date) {
    this.setState({ selectedDate: date })
  }

  onButtonClick () {
    this.props.onDateSelected(this.state.selectedDate)
  }

  render () {
    const {
      page,
      daysPerPage,
      availability,
      selectedDate
    } = this.state

    const formattedDate = formatDate('dddd D [a las] kk:mm', selectedDate)

    return (
      <Measure
        whitelist={['width']}
        onMeasure={this.setDaysPerPage}
        >
        <div>
          <h4>Elige el día y hora para tu servicio:</h4>
          <div className='AliadaProfileAvailability'>
            <AliadaProfileAvailabilityHeader
              page={page}
              availability={availability}
              daysPerPage={daysPerPage}
              onPageChange={this.onPageChange}
            />
            <div className='AliadaProfileAvailability-page'>
              <Page
                onChange={this.onDateSelected}
                page={page}
                daysPerPage={daysPerPage}
                availability={availability}
                selectedDate={selectedDate}
              />
            </div>
          </div>
          <button className='btn btn-lg btn-primary btn-block' onClick={this.onButtonClick}>Reservar para el {formattedDate} </button>
        </div>
      </Measure>
    )
  }
}

AliadaProfileAvailability.displayName = 'AliadaProfileAvailability'
AliadaProfileAvailability.propTypes = {
  availability: PropTypes.object.isRequired,
  onDateSelected: PropTypes.func.isRequired,
  dateSelected: PropTypes.object.isRequired
}
export default AliadaProfileAvailability



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/AliadaProfile/components/AliadaProfileAvailability/AliadaProfileAvailability.js